// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/main.scss
// module id = 1
// module chunks = 0